import { render, staticRenderFns } from "./ModalCadastroPeriodo.vue?vue&type=template&id=26c9a6ee"
import script from "./ModalCadastroPeriodo.vue?vue&type=script&lang=js"
export * from "./ModalCadastroPeriodo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports